import {
  firstNameForSort,
  _fullNameWithNickName,
  fullNameForSort,
  fullNameWithEmail,
  getTechnicianSelfName,
  id,
  initials,
  lastNameForSort,
  _fullName,
  fullNameForSortWithNickName,
} from "../../entity-service/technician-entity-service";
import { Model } from "@vuex-orm/core";
import { timeZoneEntity } from "./time-zone-entity";

export interface technicianProfileSetting {
  technicianId: number;
  avatarBackgroundColor: string;
  textColor: string;
  profileImageUrl: string | null;
}

export interface technicianEntity {
  technicianId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  nickName: string;
  shortName: string;
  email: string;
  roleId: number;
  roleName: string;
  technicianGroupId: number;
  technicianGroup: string;
  serviceProviderLocationId: number;
  serviceProviderId: number;
  timeZone: string;
  isSignupUser: boolean;
  isRemoteOnly: boolean;
  statusId: number;
  createdOn: string;
  createdById: number;
  updatedOn: string;
  updatedById: number;
  themeId: number;
  tick: number;
  notificationViewedDate: string;
  alertViewedDate: string;
  timeZoneEntity: timeZoneEntity;
  isResetPasswordOccurred: boolean;
  isActionButtonOpen: boolean; //will only be used for UI
  isFilling: boolean;
  billingRole: number;
  hourlyRate: number;
  baseRoleIds: number[];
  workTypeId: number;
  limitClosedTicketInMonths: number;
  subscribedGroupIds: number[];
  universalDataRefresh: number;
  showPersonalizedName: boolean;
  showServiceProviderName: boolean;
  emailSignature: string;
  currentLocation: string;
  serviceProviderType: number;
  ticketLogAccessedOn: string;
  isOutlookCalendarSync: boolean;
  profileSetting: technicianProfileSetting | null;
}

export class technicianEntity extends Model {
  static entity = "technicianEntity";
  static primaryKey = "technicianId";
  static fields() {
    return {
      technicianId: this.number(0),
      firstName: this.string(""),
      middleName: this.string(""),
      lastName: this.string(""),
      nickName: this.attr(null),
      shortName: this.string(null),
      email: this.string(""),
      roleId: this.number(0),
      roleName: this.string(null),
      technicianGroupId: this.number(0),
      technicianGroup: this.string(null),
      serviceProviderLocationId: this.number(null),
      serviceProviderId: this.number(null),
      timeZone: this.string(null),
      isSignupUser: this.boolean(null),
      isRemoteOnly: this.boolean(null),
      statusId: this.number(null),
      createdOn: this.attr(""),
      createdById: this.number(0),
      updatedOn: this.attr(""),
      updatedById: this.number(null),
      themeId: this.number(null),
      tick: this.number(0),
      notificationViewedDate: this.attr(null),
      alertViewedDate: this.attr(null),
      timeZoneEntity: this.hasOne(timeZoneEntity, "value", "timeZone"),
      isResetPasswordOccurred: this.boolean(false),
      isActionButtonOpen: this.boolean(false), //will only be used for UI
      isFilling: this.boolean(true),
      billingRole: this.number(0),
      hourlyRate: this.number(0),
      baseRoleIds: this.attr(null),
      workTypeId: this.number(0),
      limitClosedTicketInMonths: this.number(0),
      subscribedGroupIds: this.attr(null),
      universalDataRefresh: this.number(0),
      showPersonalizedName: this.boolean(false),
      showServiceProviderName: this.boolean(false),
      emailSignature: this.string(""),
      currentLocation: this.attr(null),
      serviceProviderType: this.number(0),
      ticketLogAccessedOn: this.attr(null),
      isOutlookCalendarSync: this.boolean(false),
      profileSetting: this.attr(null),
    };
  }

  static beforeSelect(records: any) {
    return records.filter((row: any) => row.technicianId != 0);
  }

  get fullName() {
    return _fullName(this.technicianId);
  }

  get fullNameWithNickName() {
    return _fullNameWithNickName(this.technicianId);
  }

  get firstNameForSort() {
    return firstNameForSort(this.firstName);
  }
  get lastNameForSort() {
    return lastNameForSort(this.lastName);
  }

  get getTechnicianSelfName() {
    return getTechnicianSelfName(
      this.technicianId,
      this.firstName,
      this.lastName,
    );
  }

  get initials() {
    return initials(this.firstName, this.lastName);
  }

  get fullNameForSort() {
    return fullNameForSort(this.firstName, this.lastName);
  }

  get fullNameForSortWithNickName() {
    return fullNameForSortWithNickName(
      this.firstName,
      this.lastName,
      this.nickName,
    );
  }

  get id() {
    return id(this);
  }

  get fullNameWithEmail() {
    return fullNameWithEmail(this.technicianId, this.email);
  }

  get avatarBackgroundColor(): string {
    return this.profileSetting?.avatarBackgroundColor;
  }

  get avatarTextColor(): string | undefined {
    return this.profileSetting?.textColor;
  }
}
